<template>
  <div>
    <link
      rel="stylesheet"
      href="https://cdnjs.cloudflare.com/ajax/libs/normalize/8.0.1/normalize.css"
    />
    <link
      rel="stylesheet"
      href="https://stackpath.bootstrapcdn.com/bootstrap/4.3.1/css/bootstrap.min.css"
      integrity="sha384-ggOyR0iXCbMQv3Xipma34MD+dH/1fQ784/j6cY/iJTQUOhcWr7x9JvoRxT2MZw1T"
      crossorigin="anonymous"
    />

    <aside class="content-wrapper">
      <section class="content fontstyle">
        <div style="font-size: 14px">
          <slot></slot>
        </div>
      </section>
    </aside>
  </div>
</template>

<script>
export default {};
</script>
<style lang="scss" scoped>
.body {
  font-family: "Times New Roman", Helvetica, sans-serif;
}
.content-wrapper {
  display: block;
  background-color: #ecf0f5;
}
.content {
  min-height: 250px;
  padding: 15px;
  margin-right: 0px;
  margin-left: 0px;
  padding-left: 15px;
  padding-right: 15px;
}
table {
  table-layout: fixed;
}
.header table,
th,
td {
  border: 1px solid black;
  border-collapse: collapse;
  padding: 10px;
  // width: 100%;
}
.header td {
  padding: 10px;
}

.table-border {
  table-layout: fixed;
}

.table-border tr td {
  padding: 3px;
  padding-left: 10px;
  border: solid 1px black;
}

.table-border tr th {
  padding: 5px;
  border: solid 1px black;
}

.content.fontstyle {
  font-family: Times New Roman, Helvetica, sans-serif;
  font-weight: 400;
}

.smaller-text {
  font-size: 12px;
}

.no-bottom {
  border-bottom: none !important;
}

.no-top {
  border-top: none !important;
}

tr.footer {
  border: none;
  font-weight: bold;
}

tr.footer td {
  padding-bottom: 2px !important;
  padding-top: 2px !important;
}

@media print {
  .table-border {
    border: solid 1px black !important;
  }
  thead tr th {
    page-break-inside: avoid;
  }
  thead {
    display: table-row-group;
  }
}
</style>
